module.exports = __webpack_public_path__ + "img/mewm.a949db83.png";